<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="2" sm="2" md="2">
              <v-text-field
                outlined
                dense
                v-model="menuItem.name"
                label="Name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" sm="2" md="2">
              <v-text-field
                outlined
                dense
                v-model="menuItem.order"
                label="Order"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" sm="2" md="2">
              <v-select
                outlined
                dense
                :items="$store.state.MenuItemsStore.menuItemTypes"
                v-model="menuItem.menuItemTypeId"
                label="Menu Item Type"
                item-text="name"
                item-value="typeId"
              ></v-select
            ></v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="blue darken-1"
          :disabled="saveButtonDisabled"
          @click="save"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card outlined class="pa-4">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">Linked POIs</v-col>
                <v-col cols="8" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <v-btn
                      v-if="open"
                      v-on:click="openPoiDialog"
                      class="ma-2"
                      absolute
                      >Link existing pois</v-btn
                    >
                    <span v-else key="1"></span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list-item>
              <v-list-item-content>
                <poi-list
                  :poi-list="this.$store.state.PoiStore.pois"
                ></poi-list>
              </v-list-item-content>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <v-card outlined class="pa-4 mt-4">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col cols="4">Linked Media</v-col>
                <v-col cols="8" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0"></span>
                    <span v-else key="1"></span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list-item>
              <v-list-item-content>
                <media :media="this.$store.state.MediaStore.media"></media>
              </v-list-item-content>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <link-with-poi-dialog
      v-if="showPoiDialog"
      :showDialog="showPoiDialog"
      @cancel="closePoiDialog"
      @done="closePoiDialog"
    ></link-with-poi-dialog>
    <link-with-media-dialog
      v-if="showMediaDialog"
      :menuItemId="$route.params.menuItemId"
      :showDialog="showMediaDialog"
      @cancel="closeMediaDialog"
      @done="closeMediaDialog"
    ></link-with-media-dialog>
  </div>
</template>

<script>
import MenuItemPoiCard from '../components/MenuItemPoiCard'
import LinkWithPoiDialog from '../components/LinkWithPoiDialog'
import MenuItemMediaCard from '../components/MenuItemMediaCard'
import LinkWithMediaDialog from '../components/LinkWithMediaDialog'
import PoiList from '../components/RecordLists/PoiList'
import Media from '../views/Media'

export default {
  components: {
    LinkWithPoiDialog,
    LinkWithMediaDialog,
    PoiList,
    Media
  },
  computed: {
    showPoiDialog: {
      get: function() {
        return this.showPoi
      },
      set: function(newValue) {
        this.showPoi = newValue
      }
    },
    showMediaDialog: {
      get: function() {
        return this.showMedia
      },
      set: function(newValue) {
        this.showMedia = newValue
      }
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    }
  },
  data() {
    return {
      name: 'Default Menu Item Name',
      showPoi: false,
      showMedia: false,
      gridViewMedia: true,
      gridViewPoi: true,
      menuItem: {},
      changeDetected: false
    }
  },
  created: function() {},
  methods: {
    getData: async function(menuItemId) {
      await this.$store.dispatch('MenuItemsStore/selectMenuItem', menuItemId)
      this.menuItem = JSON.parse(
        JSON.stringify(this.$store.state.MenuItemsStore.selectedMenuItem)
      )
      await this.$store.dispatch('PoiStore/setPoiContext', 'menu_item')
      await this.$store.dispatch('PoiStore/fetchPois')
      await this.$store.dispatch('MediaStore/setMediaContext', 'menu_item')
      await this.$store.dispatch('MenuItemsStore/fetchMenuItemTypes')
      console.log('types ', this.$store.state.MenuItemsStore.menuItemTypes)
      await this.$store.dispatch('MediaStore/fetchMedia')
      await this.$store.dispatch('MediaStore/fetchMediaTypes')
    },
    openPoiDialog: function() {
      if (!this.showPoiDialog) {
        this.showPoiDialog = true
      }
    },
    closePoiDialog: function() {
      if (this.showPoiDialog) {
        this.showPoiDialog = false
      }
    },
    openMediaDialog: function() {
      if (!this.showMediaDialog) {
        this.showMediaDialog = true
      }
    },
    closeMediaDialog: function() {
      if (this.showMediaDialog) {
        this.showMediaDialog = false
      }
    },
    save: async function() {
      await this.$store.dispatch('MenuItemsStore/updateMenuItem', this.menuItem)
      await this.$store.dispatch(
        'MenuItemsStore/selectMenuItem',
        this.menuItem.id
      )
      this.menuItem = JSON.parse(
        JSON.stringify(this.$store.state.MenuItemsStore.selectedMenuItem)
      )
      this.changeDetected = false
    }
  },
  watch: {
    menuItem: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        console.log('WATCH')

        if (
          JSON.stringify(before) !== '{}' &&
          JSON.stringify(this.menuItem) !==
            JSON.stringify(this.$store.state.MenuItemsStore.selectedMenuItem)
        ) {
          this.changeDetected = true
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData(parseInt(to.params.menuItemId))
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.getData(to.params.menuItemId)
    next()
  }
}
</script>

<style scoped></style>
